import auth from "../Middlewares/auth";

import Index from "../../Components/Pages/Clients/Index";

export const routes = [
    {
        path: '/clients',
        name: 'clients',
        component: Index,
        meta: {
            title: "Clients",
            menu: 'left',
            icon: 'mdi-handshake-outline',
            middleware: [
                auth
            ],
        }
    }
]
